import { filterAllTruthyInTuple } from "core/rx-js";
import { Observable, map } from "rxjs";
import { _IDataSourceControlBase } from "../types/i-data-source-control.base";


const mapTemplateValue = <T extends { [key: string]: any }>() => (obs: Observable<readonly [_IDataSourceControlBase['template'], T]>) =>
  obs.pipe(
    filterAllTruthyInTuple(),
    map(([matOptionTemplate, item]) => ({
      title: matOptionTemplate.title ? item[matOptionTemplate.title] : null,
      subtitle: matOptionTemplate.subtitle ? item[matOptionTemplate.subtitle] : null,
      description: matOptionTemplate.description ? item[matOptionTemplate.description] : null,
      imgSrc: matOptionTemplate.imgSrc ? 'data:image/png;base64,' + item[matOptionTemplate.imgSrc] : null
    }))
  )



export default mapTemplateValue;
